'use client';
import React from 'react';

interface QuoteBannerProps {
  quote: string;
  bgImage?: string;
  overlay?: string;
  variant?: 'default' | 'mint';
}

export default function QuoteBanner({ quote, bgImage, overlay = 'bg-black/60', variant = 'default' }: QuoteBannerProps) {
  // Mint/sage green style — matches reference image
  if (variant === 'mint') {
    return (
      <section className="relative py-14 md:py-20 overflow-hidden" style={{ backgroundColor: '#e8f0ec' }}>
        <div className="container mx-auto px-8 md:px-16 max-w-5xl relative">
          {/* Opening quote mark */}
          <span
            className="absolute -top-2 left-6 md:left-12 text-8xl md:text-9xl leading-none select-none"
            style={{ color: '#b8860b', fontFamily: 'Georgia, serif', lineHeight: 1 }}
            aria-hidden="true"
          >
            &ldquo;
          </span>

          {/* Quote text */}
          <p className="text-gray-800 font-avenir text-lg md:text-xl lg:text-2xl leading-relaxed text-center px-8 md:px-16 pt-10 pb-6">
            {quote}
          </p>

          {/* Closing quote mark */}
          <span
            className="absolute bottom-0 right-6 md:right-12 text-8xl md:text-9xl leading-none select-none"
            style={{ color: '#b8860b', fontFamily: 'Georgia, serif', lineHeight: 1 }}
            aria-hidden="true"
          >
            &rdquo;
          </span>
        </div>
      </section>
    );
  }

  if (!bgImage) {
    // Light style with left border
    return (
      <section className="relative py-16 md:py-20 overflow-hidden bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="border-l-4 border-brand-turmeric pl-8">
            <h5 className="text-gray-700 font-avenir text-lg md:text-xl lg:text-2xl leading-relaxed font-medium italic">
              {quote}
            </h5>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className="relative py-16 md:py-20 overflow-hidden"
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}
    >
      {/* Overlay */}
      <div className={`absolute inset-0 ${overlay}`} />

      <div className="relative z-10 container mx-auto px-4 max-w-4xl text-center">
        <div className="flex flex-col items-center">
          <h5 className="text-white font-avenir text-lg md:text-xl lg:text-2xl leading-relaxed font-medium italic">
            {quote}
          </h5>
        </div>
      </div>
    </section>
  );
}
